// extracted by mini-css-extract-plugin
export default {"input-box":"InputProcessInvoice_input-box__OvxMN","label":"InputProcessInvoice_label__ykkoH","input":"InputProcessInvoice_input__VHkHQ","button":"InputProcessInvoice_button__1jxWm"};